import { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import MainCard from 'components/MainCard';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  title?: boolean;
}

// Content-shaped placeholder for tables / data grids: an optional title row,
// a header strip, then evenly spaced row lines. Mirrors the rhythm of a
// MainCard-wrapped table so the swap from skeleton to data is seamless.
const TableSkeleton: FC<TableSkeletonProps> = ({ rows = 8, columns = 5, title = true }) => (
  <MainCard
    title={title ? <Skeleton variant="text" width={180} height={28} /> : undefined}
    secondary={title ? <Skeleton variant="rounded" width={120} height={36} /> : undefined}
  >
    <Stack spacing={1.5}>
      {/* header strip */}
      <Stack direction="row" spacing={2} sx={{ pb: 1 }}>
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={`h-${i}`} variant="text" height={22} sx={{ flex: 1 }} />
        ))}
      </Stack>
      {/* rows */}
      {Array.from({ length: rows }).map((_, r) => (
        <Stack key={`r-${r}`} direction="row" spacing={2} alignItems="center">
          {Array.from({ length: columns }).map((_, c) => (
            <Box key={`c-${r}-${c}`} sx={{ flex: 1 }}>
              <Skeleton variant="rounded" height={18} width={c === 0 ? '80%' : '60%'} />
            </Box>
          ))}
        </Stack>
      ))}
    </Stack>
  </MainCard>
);

export default TableSkeleton;
